import moment from 'moment'
import http from '@/api/freight.js' //请求汇总

export default {
    data() {
        return {
            hasWeekOfYear: {},

            curY: moment().year(),
            curM: 1 + moment().month(),
        }
    },
    computed: {
        curYMWeek() {
            return (
                (this.hasWeekOfYear[this.curY] &&
                    this.hasWeekOfYear[this.curY][this.curM]) ||
                []
            )
        },
    },
    mounted() {
        this.curY = this.$route.query.year ? this.$route.query.year : this.curY
        this.curM = this.$route.query.month ? this.$route.query.month : this.curM
        this.getWeek()
    },
    methods: {
        async getWeek() {
            let year = this.curY
            if (this.hasWeekOfYear.hasOwnProperty(year)) return

            // 填充该年所有月份的周
            let tmpWeekOfYear = {}
            for (let month = 1; month <= 12; month++) {
                let firstDayOfMonth = moment(`${year}/${month}/1`)
                let tmpWeekNum = 0
                let allDayCountOfMonth = firstDayOfMonth.daysInMonth()

                for (let i = 0; i < allDayCountOfMonth; i++) {
                    if (0 === moment(firstDayOfMonth).add(i, 'days').weekday()) {
                        tmpWeekNum++
                    }
                }
                tmpWeekOfYear[month] = Array(tmpWeekNum)
                    .fill('')
                    .map((_, i) => ({
                        selected: false,
                        disabled: true,
                        month,
                        year,
                        week: i + 1,
                    }))
            }
            this.$set(this.hasWeekOfYear, year, tmpWeekOfYear)

            http
                .getWeekDataDistribute3({year: this.curY})
                .then((e) => {
                    let tmpData = e.data || {}
                    for (let month in tmpData) {
                        tmpWeekOfYear[month].forEach((week) => {
                            if (tmpData[month].find((_) => _ == week.week)) {
                                week.disabled = false
                            }
                        })
                    }
                })
                .catch((err) => {
                    console.error(err)
                    this.$delete(this.hasWeekOfYear, year)
                })
        },

        onPrevY() {
            this.curY--
            this.getWeek()
        },
        onNextY() {
            this.curY++
            this.getWeek()
        },
        onPrevM() {
            if (1 == this.curM) {
                this.curM = 12
                this.curY--
            } else {
                this.curM--
            }
            this.getWeek()
        },
        onNextM() {
            if (12 == this.curM) {
                this.curM = 1
                this.curY++
            } else {
                this.curM++
            }
            this.getWeek()
        },
    },
}
